var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.646,
    height: 130.127,
    viewBox: "0 0 129.646 130.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0.01 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(-0.01 -0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M100.972,58.021H67.509A14.289,14.289,0,0,1,53.476,43.988V11.064A6.066,6.066,0,0,0,46.46,4.048,54.128,54.128,0,0,0,1.123,68.815c3.778,21.049,21.049,37.781,42.1,42.1a54.385,54.385,0,0,0,64.767-45.337C108.528,61.259,105.29,58.021,100.972,58.021Z",
    transform: "translate(0.01 18.081)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M76.767,57.651a64.687,64.687,0,0,0-18.89-38.86A66.271,66.271,0,0,0,19.016-.1,7.144,7.144,0,0,0,12,6.916V59.81a5.409,5.409,0,0,0,5.4,5.4H70.291A6.56,6.56,0,0,0,76.767,57.651Z",
    transform: "translate(52.82 0.1)",
    fill: "#117446"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.8c7d61a270b2ef730a5f310524aceec8.svg";
export { ForwardRef as ReactComponent };